import { MASTERMULTITOTAL } from "../constants/multiCinemaModes"

const getCinemaStyles = (settings, cinemas) => {
    const {cinemaColors, multiCinemaMode, multitotalStyle, themeColors} = settings
    let colorSettings = {}
    
    if(multiCinemaMode === MASTERMULTITOTAL) {
        if(themeColors === 'Arthouse') {
            if(multitotalStyle === 'colored' || multitotalStyle === 'default') {
                if(cinemas.length === 1) {
                    const currentCinema = cinemas[0]
                    const currentCinemaSettings = cinemaColors[currentCinema] ? cinemaColors[currentCinema] : {}
                    colorSettings = currentCinemaSettings
                }
            } 
        }
    }
    
    return colorSettings
}

export default getCinemaStyles